require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./veniam-consequatur-enim-vitae.json") })
        }
      }, "path---veniam-consequatur-enim-vitae");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---veniam-consequatur-enim-vitae!./.cache/json/veniam-consequatur-enim-vitae.json
// module id = 403
// module chunks = 231608221292675